// SetupCartLineDetail.jsx
import React from 'react';
import LineClose from "~/assets/icons/LineClose";
import PlusCuestion from "~/assets/icons/PlusCuestion";

interface SetupCartLineDetailProps {
    optionsSelected: any; // Reemplaza 'any' con el tipo correcto si lo conoces
    merchandiseId: string;
    showItem: boolean;
    setShowItem: React.Dispatch<React.SetStateAction<boolean>>;
}

const SetupCartLineDetail: React.FC<SetupCartLineDetailProps> = ({ optionsSelected, merchandise, showItem, setShowItem }) => {
    return (
        <li className='more-detail-wrapper' onClick={() => setShowItem(!showItem)}>
            <div className="topArea">
                <span className={`more-detail ${showItem ? "open-accordion" : "close-accordion"}`}><LineClose /><PlusCuestion />Details</span>

            </div>

            {showItem &&
                <div className='itemsWrapper'>

                    {optionsSelected?.cartLineItems
                        .find(c => c.lineItemId == merchandise.id?.split('/')[merchandise.id?.split('/').length - 1])
                        ?.options
                        .map((op: any) => (
                            <>
                                <div className='detail-more-detail'>
                                    {(op?.group || op?.option?.Title) && <p><strong>{op?.group || `Option : `}</strong> {op?.option?.Title && <span>{op?.option?.Title}</span>}</p>}

                                    {op?.option?.Image && <img height={50} width={50} src={op?.option?.Image} />}
                                </div>
                            </>
                        ))}
                </div>
            }
        </li>
    );
};

export default SetupCartLineDetail;
